var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69447 7.78299C11.8437 7.78299 13.586 6.04071 13.586 3.8915C13.586 1.74228 11.8437 0 9.69447 0C7.54526 0 5.80298 1.74228 5.80298 3.8915C5.80298 6.04071 7.54526 7.78299 9.69447 7.78299Z",
    fill: "#1A2CCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3323 16.7858C18.9287 14.9479 18.003 13.2656 16.6666 11.9409C16.3423 11.6154 15.9908 11.3181 15.6159 11.0523C13.9089 9.77186 11.8282 9.08817 9.69438 9.10656C7.08522 9.09321 4.57661 10.112 2.71563 11.9409C1.37923 13.2656 0.453621 14.9479 0.0499554 16.7858C-0.0202077 17.1108 -0.0164176 17.4474 0.0610454 17.7707C0.138508 18.094 0.287663 18.3958 0.497477 18.6537C0.714768 18.9171 0.988394 19.1285 1.2982 19.2722C1.608 19.4159 1.94609 19.4882 2.28757 19.4839H17.1012C17.4437 19.4841 17.7818 19.4073 18.0905 19.2591C18.3993 19.1109 18.6707 18.8951 18.8848 18.6278C19.0908 18.3729 19.2378 18.0755 19.3152 17.757C19.3926 17.4385 19.3984 17.1068 19.3323 16.7858Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c6913e87e6611bc5822d15afa2740e78.svg";
export { ForwardRef as ReactComponent };